<template>
  <v-row no-gutters>
    <v-col cols="12" class="mb-6">
      <span class="header__title--main">
        {{ $t('message.pages.analytics.account.views') }}
      </span>
    </v-col>
    <v-card v-if="noInfoFound" width="1000px" height="300px" flat>
      <empty-state />
    </v-card>
    <template v-else>
      <v-col cols="12" class="pl-4">
        <v-row no-gutters>
          <v-card width="180px" flat>
            <v-row no-gutters>
              <v-card
                width="26px"
                height="26px"
                class="rounded-circle mr-2 mt-1"
                color="#368EF4"
                style="border: 5px solid #9dcaff !important"
              ></v-card>
              <v-row no-gutters class="flex-column">
                <v-col>
                  <v-skeleton-loader
                    v-if="loadings.fetch"
                    class="rounded pb-1"
                    type="chip"
                    height="28"
                    width="70"
                    tile
                  ></v-skeleton-loader>
                  <span class="text-h5 font-weight-medium" v-else>
                    {{ Number(totalData.views).toLocaleString() }}
                  </span>
                </v-col>
                <v-col>
                  <span>{{ $t('message.pages.analytics.account.views') }}</span>
                  <LearnMoreBtn
                    :customTooltipMessage="
                      $t('message.pages.analytics.views.tooltipMessages.views')
                    "
                    :onClickBtn="() => handleGoToAnalyticsArticle()"
                    customTooltipMessageStyle="max-width: 300px;"
                    customClass="ask__btn--tiny"
                  />
                </v-col>
              </v-row>
            </v-row>
          </v-card>
          <v-card width="220px" flat class="mr-6">
            <v-row no-gutters>
              <v-card
                width="26px"
                height="26px"
                class="rounded-circle mr-2 mt-1"
                color="#5BC6AC"
                style="border: 5px solid #99fae2 !important"
              ></v-card>
              <v-row no-gutters class="flex-column">
                <v-col>
                  <v-skeleton-loader
                    v-if="loadings.fetch"
                    class="rounded pb-1"
                    type="chip"
                    height="28"
                    width="70"
                    tile
                  ></v-skeleton-loader>
                  <span v-else class="text-h5 font-weight-medium">{{
                    Number(totalData.uniqueViews).toLocaleString()
                  }}</span>
                </v-col>
                <v-col>
                  <span
                    >{{ $t('message.pages.analytics.account.uniqueViews')
                    }}<LearnMoreBtn
                      :customTooltipMessage="
                        $t(
                          'message.pages.analytics.views.tooltipMessages.uniqueViews'
                        )
                      "
                      :onClickBtn="() => handleGoToAnalyticsArticle()"
                      customTooltipMessageStyle="max-width: 300px;"
                      customClass="ask__btn--tiny"
                  /></span>
                </v-col>
              </v-row>
            </v-row>
          </v-card>
          <v-card width="160px" flat>
            <v-row no-gutters>
              <v-card
                width="26px"
                height="26px"
                class="rounded-circle mr-2 mt-1 orange"
                style="border: 5px solid #ffcc80 !important"
              ></v-card>
              <v-row no-gutters class="flex-column">
                <v-col>
                  <v-skeleton-loader
                    v-if="loadings.fetch"
                    class="rounded pb-4"
                    type="chip"
                    height="28"
                    width="70"
                    tile
                  ></v-skeleton-loader>
                  <template v-else>
                    <span class="text-h5 font-weight-medium">{{
                      Number(totalData.plays).toLocaleString()
                    }}</span>
                    <sup> {{ totalData.playRate }}%</sup>
                  </template>
                </v-col>
                <v-col>
                  <span
                    >{{ $t('message.pages.analytics.account.plays')
                    }}<LearnMoreBtn
                      :customTooltipMessage="
                        $t(
                          'message.pages.analytics.views.tooltipMessages.plays'
                        )
                      "
                      :onClickBtn="() => handleGoToAnalyticsArticle()"
                      customTooltipMessageStyle="max-width: 300px;"
                      customClass="ask__btn--tiny"
                  /></span>
                </v-col>
              </v-row>
            </v-row>
          </v-card>
          <v-card width="170px" flat>
            <v-row no-gutters>
              <v-card
                width="26px"
                height="26px"
                class="rounded-circle mr-2 mt-1 purple"
                style="border: 5px solid #ce93d8 !important"
              ></v-card>
              <v-row no-gutters class="flex-column">
                <v-col>
                  <v-skeleton-loader
                    v-if="loadings.fetch"
                    class="rounded pb-1"
                    type="chip"
                    height="28"
                    width="70"
                    tile
                  ></v-skeleton-loader>
                  <template v-else>
                    <span class="text-h5 font-weight-medium">
                      {{ Number(totalData.uniquePlays).toLocaleString() }}
                    </span>
                    <sup> {{ totalData.uniquePlayRate }}%</sup>
                  </template>
                </v-col>
                <v-col>
                  <span
                    >{{ $t('message.pages.analytics.account.uniquePlays')
                    }}<LearnMoreBtn
                      :customTooltipMessage="
                        $t(
                          'message.pages.analytics.views.tooltipMessages.uniquePlays'
                        )
                      "
                      :onClickBtn="() => handleGoToAnalyticsArticle()"
                      customTooltipMessageStyle="max-width: 300px;"
                      customClass="ask__btn--tiny"
                  /></span>
                </v-col>
              </v-row>
            </v-row>
          </v-card>
        </v-row>
      </v-col>
      <v-col cols="12" class="px-0">
        <v-col cols="12" class="px-0">
          <v-row class="mt-4" v-if="loadings.fetch" no-gutters>
            <v-card
              flat
              width="100%"
              height="250px"
              class="d-flex flex-row align-center justify-center"
            >
              <loading-logo :value="200" />
            </v-card>
          </v-row>
          <v-card
            class="d-flex flex-row align-center justify-center"
            flat
            height="250px"
            width="100%"
            v-else-if="errors.unknownError"
          >
            <ad-block-error-message
              v-if="isAdBlockEnabled"
              :isLoading="loadings.fetch"
              @handleFetchData="handleUpdateAnalytics"
            />
            <v-row
              class="flex-column"
              justify="center"
              align="center"
              no-gutters
              v-else
            >
              <v-card flat height="30" class="mb-4">
                <span class="footerText align-text d-block">
                  {{ errors.shownErrMsg }}
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon size="18" v-bind="attrs" v-on="on">
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <v-container
                      class="text-body-2 pa-0"
                      style="max-width: 230px"
                    >
                      {{ errors.tooltipErrMsg }}
                    </v-container>
                  </v-tooltip>
                </span>
              </v-card>
              <v-btn
                color="primary"
                class="ml-3"
                @click="handleUpdateAnalytics"
                >{{ $t('message.pages.analytics.tryAgain') }}</v-btn
              >
            </v-row>
          </v-card>
          <apexchart
            v-else
            :class="{ darkThemeSvgFix: $vuetify.theme.dark }"
            type="area"
            height="250"
            :options="viewsChartOptions"
            :series="viewChartSeries"
          ></apexchart>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="4" class="pr-2">
              <v-text-field
                v-if="!loadings.fetch"
                v-model="searchVideoText"
                dense
                outlined
                :label="$t('message.pages.analytics.account.search')"
                prepend-inner-icon="mdi-magnify"
                hide-details
                @input="doItemsSearch"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-card class="mt-1" flat width="100%" height="45px">
          <v-row no-gutters v-if="!loadings.fetch" class="pointer pl-7">
            <v-col
              class="d-flex align-center justify-start"
              style="width: 100%"
            >
              <v-hover v-slot="{ hover }">
                <v-row no-gutters @click="handleOrderByName">
                  <span
                    class="caption mt-1"
                    style="height: 24px; color: var(--v-blueMarine-base)"
                  >
                    <b>{{ $t('message.pages.videosDataTable.header.name') }}</b>
                  </span>
                  <v-icon v-if="hover && !nameOrder" color="grey lighten-1"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && nameOrder === 'desc'"
                    >mdi-menu-down</v-icon
                  >
                  <v-icon v-if="hover && nameOrder === 'asc'"
                    >mdi-menu-up</v-icon
                  >
                </v-row>
              </v-hover>
            </v-col>
            <v-card
              class="d-flex align-center"
              height="45px"
              flat
              width="150px"
            >
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByViews"
                  justify="end"
                  align="center"
                >
                  <span
                    class="caption mt-1"
                    style="height: 24px; color: var(--v-blueMarine-base)"
                  >
                    <b>{{ $t('message.pages.analytics.account.views') }}</b>
                  </span>
                  <LearnMoreBtn
                    :customTooltipMessage="
                      $t('message.pages.analytics.views.tooltipMessages.views')
                    "
                    :onClickBtn="() => handleGoToAnalyticsArticle()"
                    customTooltipMessageStyle="max-width: 300px;"
                    customClass="ask__btn--tiny"
                  />
                  <div :style="hover ? 'opacity: 1' : 'opacity: 0'">
                    <v-icon v-if="!viewsOrder" color="grey lighten-1"
                      >mdi-menu-down</v-icon
                    >
                    <v-icon v-if="viewsOrder === 'desc'">mdi-menu-down</v-icon>
                    <v-icon v-if="viewsOrder === 'asc'">mdi-menu-up</v-icon>
                  </div>
                </v-row>
              </v-hover>
            </v-card>
            <v-card class="d-flex align-center" height="45px" flat width="95px">
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByPlays"
                  justify="end"
                  align="center"
                >
                  <span
                    class="caption mt-1"
                    style="height: 24px; color: var(--v-blueMarine-base)"
                  >
                    <b>{{ $t('message.pages.analytics.account.plays') }}</b>
                  </span>
                  <LearnMoreBtn
                    :customTooltipMessage="
                      $t('message.pages.analytics.views.tooltipMessages.plays')
                    "
                    :onClickBtn="() => handleGoToAnalyticsArticle()"
                    customTooltipMessageStyle="max-width: 300px;"
                    customClass="ask__btn--tiny"
                  />
                  <div :style="hover ? 'opacity: 1' : 'opacity: 0'">
                    <v-icon v-if="!playsOrder" color="grey lighten-1"
                      >mdi-menu-down</v-icon
                    >
                    <v-icon v-if="playsOrder === 'desc'">mdi-menu-down</v-icon>
                    <v-icon v-if="playsOrder === 'asc'">mdi-menu-up</v-icon>
                  </div>
                </v-row>
              </v-hover>
            </v-card>
            <v-card
              class="d-flex align-center"
              height="45px"
              flat
              width="135px"
            >
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByUniqueViews"
                  justify="end"
                  align="center"
                  class="flex-nowrap"
                  style="height: 100%"
                >
                  <span class="caption break-text">
                    <b
                      v-html="$t('message.pages.analytics.account.uniqueViews')"
                    ></b>
                  </span>
                  <LearnMoreBtn
                    :customTooltipMessage="
                      $t(
                        'message.pages.analytics.views.tooltipMessages.uniqueViews'
                      )
                    "
                    :onClickBtn="() => handleGoToAnalyticsArticle()"
                    customTooltipMessageStyle="max-width: 300px;"
                    customClass="ask__btn--tiny"
                  />
                  <div :style="hover ? 'opacity: 1' : 'opacity: 0'">
                    <v-icon v-if="!uniqueViewsOrder" color="grey lighten-1"
                      >mdi-menu-down</v-icon
                    >
                    <v-icon v-if="uniqueViewsOrder === 'desc'"
                      >mdi-menu-down</v-icon
                    >
                    <v-icon v-if="uniqueViewsOrder === 'asc'"
                      >mdi-menu-up</v-icon
                    >
                  </div>
                </v-row>
              </v-hover>
            </v-card>
            <v-card
              class="d-flex align-center"
              height="45px"
              flat
              width="150px"
            >
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByUniquePlays"
                  justify="end"
                  align="center"
                >
                  <span
                    class="caption mt-1"
                    style="height: 24px; color: var(--v-blueMarine-base)"
                  >
                    <b>{{
                      $t('message.pages.analytics.account.uniquePlays')
                    }}</b>
                  </span>
                  <LearnMoreBtn
                    :customTooltipMessage="
                      $t(
                        'message.pages.analytics.views.tooltipMessages.uniquePlays'
                      )
                    "
                    :onClickBtn="() => handleGoToAnalyticsArticle()"
                    customTooltipMessageStyle="max-width: 300px;"
                    customClass="ask__btn--tiny"
                  />
                  <div :style="hover ? 'opacity: 1' : 'opacity: 0'">
                    <v-icon v-if="!uniquePlaysOrder" color="grey lighten-1"
                      >mdi-menu-down</v-icon
                    >
                    <v-icon v-if="uniquePlaysOrder === 'desc'"
                      >mdi-menu-down</v-icon
                    >
                    <v-icon v-if="uniquePlaysOrder === 'asc'"
                      >mdi-menu-up</v-icon
                    >
                  </div>
                </v-row>
              </v-hover>
            </v-card>
            <v-card
              class="d-flex align-center pl-2"
              height="45px"
              flat
              width="120px"
            >
              <v-hover v-slot="{ hover }">
                <v-row
                  no-gutters
                  @click="handleOrderByPlayrate"
                  justify="end"
                  align="center"
                >
                  <span
                    class="caption mt-1"
                    style="height: 24px; color: var(--v-blueMarine-base)"
                  >
                    <b>Playrate</b>
                  </span>
                  <LearnMoreBtn
                    :customTooltipMessage="
                      $t(
                        'message.pages.analytics.views.tooltipMessages.playrate'
                      )
                    "
                    :onClickBtn="() => handleGoToAnalyticsArticle()"
                    customTooltipMessageStyle="max-width: 300px;"
                    customClass="ask__btn--tiny"
                  />
                  <div :style="hover ? 'opacity: 1' : 'opacity: 0'">
                    <v-icon v-if="!playrateOrder" color="grey lighten-1"
                      >mdi-menu-down</v-icon
                    >
                    <v-icon v-if="playrateOrder === 'desc'"
                      >mdi-menu-down</v-icon
                    >
                    <v-icon v-if="playrateOrder === 'asc'">mdi-menu-up</v-icon>
                  </div>
                </v-row>
              </v-hover>
            </v-card>
          </v-row>
        </v-card>
        <v-col cols="12" class="pa-0 ml-2 pb-4">
          <v-row no-gutters>
            <v-col cols="12" v-if="loadings.fetch">
              <v-skeleton-loader type="table-tbody" />
            </v-col>
            <vue-virtual-table
              v-else-if="videosData.length"
              class="analyticsTable"
              :config="headers"
              :data="
                searchVideoText.length > 0 ? filteredRankingItems : videosData
              "
              :height="tableHeight"
              :itemHeight="48"
              :minWidth="450"
            >
              <template slot-scope="scope" slot="titleCommon">
                <v-col
                  class="d-flex align-center justify-start pa-0"
                  style="padding-left: 15px !important"
                >
                  <span
                    :title="scope.row.title"
                    class="text-truncate"
                    :style="'max-width: 100%'"
                    >{{ scope.row.title ? scope.row.title : '-' }}</span
                  >
                </v-col>
              </template>
              <template slot-scope="scope" slot="view">
                <v-row no-gutters justify="end">
                  <span>{{ Number(scope.row.view).toLocaleString() }}</span>
                </v-row>
              </template>
              <template slot-scope="scope" slot="play">
                <v-row no-gutters justify="end">
                  <span>{{
                    Number(scope.row.play)
                      ? `${Number(scope.row.play).toLocaleString()}`
                      : '0'
                  }}</span>
                </v-row>
              </template>
              <template slot-scope="scope" slot="uniqueView">
                <v-row no-gutters justify="end">
                  <span>
                    {{
                      Number(scope.row.unique_view)
                        ? `${Number(scope.row.unique_view).toLocaleString()}`
                        : '0'
                    }}
                  </span>
                </v-row>
              </template>
              <template slot-scope="scope" slot="uniquePlay">
                <v-row no-gutters justify="end">
                  <span>
                    {{
                      Number(scope.row.unique_play)
                        ? `${Number(scope.row.unique_play).toLocaleString()}`
                        : '0'
                    }}
                  </span>
                </v-row>
              </template>
              <template slot-scope="scope" slot="playrate">
                <v-row
                  no-gutters
                  justify="end"
                  :class="tableHeight <= 288 ? 'pr-9' : 'pr-5'"
                >
                  <span>
                    {{
                      Number(scope.row.playRate)
                        ? `${Number(scope.row.playRate)}%`
                        : '0%'
                    }}
                  </span>
                </v-row>
              </template>
            </vue-virtual-table>
            <v-card
              v-else
              class="d-flex flex-row align-center justify-center"
              width="100%"
              height="316px"
              flat
            >
              <v-icon class="mb-1 mr-1" color="primary">
                mdi-folder-search-outline
              </v-icon>
              <span class="subtitle-2">{{
                $t('message.pages.analytics.account.notFound')
              }}</span>
            </v-card>
          </v-row>
        </v-col>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { format } from 'date-fns'
import i18n from '@/translations/lang'
import LoadingLogo from '@/components/LoadingLogo.vue'
import { mapState, mapMutations } from 'vuex'
import AdBlockErrorMessage from '@/components/AdBlockErrorMessage.vue'
import VueVirtualTable from 'vue-virtual-table'
import newAnalyticsApi from '@/services/newAnalyticsApi'
import Fuse from 'fuse.js'
import VueApexCharts from 'vue-apexcharts'
import EmptyState from './EmptyState.vue'
import LearnMoreBtn from '@/components/LearnMoreBtn.vue'

export default {
  name: 'Views',
  components: {
    LoadingLogo,
    AdBlockErrorMessage,
    VueVirtualTable,
    apexchart: VueApexCharts,
    EmptyState,
    LearnMoreBtn,
  },
  props: {
    componentData: {
      type: Object,
      default: () => ({ selectedVideos: [], dateRange: [] }),
      required: true,
    },
  },
  data() {
    return {
      searchVideoText: '',
      loadings: {
        fetch: true,
      },
      viewsChartOptions: {
        legend: {
          show: false,
        },
        chart: {
          toolbar: false,
          type: 'area',
          height: 350,
          width: '100%',
          offsetX: 0,
          offsetY: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: 'datetime',
          categories: [],
          labels: {
            format: 'dd/MM',
            datetimeUTC: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        tooltip: {
          theme: 'dark',
          x: {
            format: 'dd/MM/yy HH:mm',
          },
          y: {
            formatter: function (
              value,
              { seriesIndex, dataPointIndex, series }
            ) {
              if (seriesIndex === 3 && value >= 0) {
                // verifica se o "Y" atual é o de plays únicos
                const uniquePlays = value
                const uniqueViews = series[1][dataPointIndex]
                let playRate = 0
                if (uniquePlays && uniqueViews) {
                  playRate = ((uniquePlays * 100) / uniqueViews).toFixed(1)
                }
                return `${value} (${playRate}%)`
              } else if (seriesIndex === 2 && value >= 0) {
                // verifica se o "Y" atual é o de plays
                const plays = value
                const views = series[0][dataPointIndex]
                let playRate = 0
                if (plays && views) {
                  playRate = ((plays * 100) / views).toFixed(1)
                }
                return `${value} (${playRate}%)`
              }
              return value
            },
          },
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 0.95,
            opacityFrom: 0.7,
            opacityTo: 0.5,
            stops: [0, 95, 100],
          },
        },
      },
      viewChartSeries: [],
      totalData: {
        views: 0,
        uniqueViews: 0,
        plays: 0,
        uniquePlays: 0,
        playRate: 0,
        uniquePlayRate: 0,
      },
      tableData: [],
      videosData: [],
      errors: {
        fetch: false,
        unknownError: false,
        shownErrMsg: '',
        tooltipErrMsg: '',
      },
      filteredRankingItems: [],
      nameOrder: 'desc',
      viewsOrder: 'desc',
      playsOrder: 'desc',
      uniqueViewsOrder: 'desc',
      uniquePlaysOrder: 'desc',
      playrateOrder: 'desc',
      noInfoFound: false,
      analyticsLinks: {
        pt: 'https://help.pandavideo.com/pt-br/article/como-funcionam-as-metricas-do-analytics-na-panda-video-qk2m59/',
        en: 'https://help.pandavideo.com/en-us/article/how-do-analytics-metrics-work-in-panda-video-kinu6m/',
      },
    }
  },
  computed: {
    ...mapState('user', {
      planInfo: 'userPlanInfo',
    }),
    ...mapState({
      isAdBlock: (state) => state.dashboard.isAdBlockEnabled,
    }),
    headers() {
      return [
        {
          prop: '_action',
          name: 'Nome',
          actionName: 'titleCommon',
        },
        {
          prop: '_action',
          name: 'Visualizações',
          actionName: 'view',
          width: this.tableHeight <= 288 ? 110 : 100,
        },
        {
          prop: '_action',
          name: 'Plays',
          actionName: 'play',
          width: this.tableHeight <= 288 ? 90 : 90,
        },
        {
          prop: '_action',
          name: 'Visualizações Únicas',
          actionName: 'uniqueView',
          width: this.tableHeight <= 288 ? 140 : 140,
        },
        {
          prop: '_action',
          name: 'Plays Únicos',
          actionName: 'uniquePlay',
          width: this.tableHeight <= 288 ? 140 : 150,
        },
        {
          prop: '_action',
          name: 'Playrate',
          actionName: 'playrate',
          width: this.tableHeight <= 288 ? 160 : 140,
        },
      ]
    },
    tableHeight() {
      if (this.videosData.length < 5) {
        return 288
      } else if (this.videosData.length <= 100) {
        return (this.videosData.length + 1) * 48 + 5
      } else {
        return 4805
      }
    },
    isAdBlockEnabled() {
      if (this.isAdBlock) {
        return this.isAdBlock
      }
      return false
    },
    selectedVideos() {
      const { selectedVideos } = this.componentData
      return selectedVideos
    },
    dateRange() {
      const { dateRange } = this.componentData
      return dateRange
    },
  },
  watch: {
    componentData: {
      handler() {
        this.fetchAnalyticsInfo()
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.$root.$emit('checkAdBlock')
  },
  methods: {
    ...mapMutations('dashboard', ['UPDATE_IS_ADBLOCK_ENABLED']),
    handleGoToAnalyticsArticle() {
      const articleLink =
        this.analyticsLinks[this.$i18next.resolvedLanguage] ??
        this.analyticsLinks['en']
      window.open(articleLink, '_blank')
    },
    doItemsSearch() {
      let searchValue = this.searchVideoText
      if (searchValue && searchValue.length > 0) {
        let list = JSON.parse(JSON.stringify(this.videosData))
        let fuseOptions = {
          keys: ['title'],
          includeScore: true,
          threshold: 0.6,
        }
        const fuse = new Fuse(list, fuseOptions)
        let searchResult = fuse.search(searchValue)
        const itemsResults = searchResult.map((result) => result.item)
        this.filteredRankingItems = itemsResults
      } else {
        this.filteredRankingItems = []
      }
    },
    async fetchAnalyticsInfo() {
      this.noInfoFound = false
      this.totalData.views = 0
      await this.handleUpdateAnalytics()
    },
    resetGraphData() {
      Object.keys(this.totalData).forEach((e) => (this.totalData[e] = 0))
    },
    async handleUpdateAnalytics() {
      if (this.selectedVideos.length === 0 && this.dateRange[0]) {
        this.getAccountRanking()
        this.fetchData()
        return
      }
      let requestsData = {
        views_data: {},
        total: {
          play: 0,
          unique_play: 0,
          view: 0,
          unique_view: 0,
        },
      }
      this.resetGraphData()
      this.loadings.fetch = true
      let videos = []
      for (let i = 0; i < this.selectedVideos.length; i++) {
        let video = this.selectedVideos[i]
        let ret = await this.fetchVideoAnalytics(video.id)
        videos.push({
          videoExternalId: video.video_external_id,
          play: ret.total.play,
          unique_play: ret.total.unique_play,
          unique_view: ret.total.unique_view,
          view: ret.total.view,
          title: video.title,
          id: video.id,
        })
        this.totalData = {
          views: this.totalData.views + ret.total.view ?? 0,
          uniqueViews: this.totalData.uniqueViews + ret.total.unique_view ?? 0,
          plays: this.totalData.plays + ret.total.play ?? 0,
          uniquePlays: this.totalData.uniquePlays + ret.total.unique_play ?? 0,
        }
        if (i === 0) {
          requestsData = ret
        } else {
          requestsData.total.play += ret.total.play ?? 0
          requestsData.total.view += ret.total.view ?? 0
          requestsData.total.unique_view += ret.total.unique_view ?? 0
          requestsData.total.unique_play += ret.total.unique_play ?? 0
          Object.keys(requestsData.views_data).forEach((e) => {
            if (ret?.views_data[e]?.play) {
              requestsData.views_data[e] = {
                play:
                  requestsData.views_data[e].play + ret.views_data[e].play ?? 0,
                unique_play:
                  requestsData.views_data[e].unique_play +
                    ret.views_data[e].unique_play ?? 0,
                view:
                  requestsData.views_data[e].view + ret.views_data[e].view ?? 0,
                unique_view:
                  requestsData.views_data[e].unique_view +
                    ret.views_data[e].unique_view ?? 0,
              }
            }
          })
        }
      }
      if (!videos.length) this.noInfoFound = true
      this.fixAnalyticsChart(requestsData)
      this.videosData = [...videos]
      this.videosData.sort((a, b) => b.view - a.view)
      this.viewsOrder = 'desc'
      this.addPlayrate()
      this.loadings.fetch = false
    },
    addPlayrate() {
      this.videosData = this.videosData.map((video) => {
        return {
          ...video,
          playRate: ((video.unique_play * 100) / video.unique_view).toFixed(1),
        }
      })
    },
    async fetchVideoAnalytics(id) {
      try {
        let ret = await newAnalyticsApi.getSingleVideoAnalytics(
          id,
          format(this.dateRange[0], 'yyyy-MM-dd'),
          format(this.dateRange[1], 'yyyy-MM-dd')
        )
        return ret.data
      } catch (e) {
        console.log('e', e)
      }
    },
    async getAccountRanking() {
      this.loadings.fetch = true
      this.wasFetch = false
      try {
        let ret = await newAnalyticsApi.getRanking(
          format(this.dateRange[0], 'yyyy-MM-dd'),
          format(this.dateRange[1], 'yyyy-MM-dd')
        )
        if (!ret.data.length) this.noInfoFound = true
        this.videosData = ret.data
        this.videosData.sort((a, b) => b.view - a.view)
        this.viewsOrder = 'desc'
        this.addPlayrate()
      } catch (e) {
        this.loadings.fetch = false
        console.log('e', e)
      }
      this.wasFetch = true
      this.loadings.fetch = false
    },
    async fixAnalyticsChart(data) {
      if (data.total.play && data.total.view)
        this.totalData.playRate = (
          (data.total.play * 100) /
          data.total.view
        ).toFixed(1)
      else this.totalData.playRate = 0
      if (
        data.total.unique_view &&
        data.total.unique_play &&
        typeof data.total.unique_view === 'number' &&
        typeof data.total.unique_play === 'number'
      ) {
        this.totalData.uniquePlayRate = (
          (data.total.unique_play * 100) /
          data.total.unique_view
        ).toFixed(1)
      }
      if (this.selectedVideos.length) {
        this.viewsChartOptions.xaxis.labels.format = 'dd/MM HH:mm'
      }

      this.viewChartSeries = [
        {
          name: i18n.t('message.pages.video.metricsPage.views'),
          data: Object.keys(data.views_data)
            .map((item) => ({
              x: new Date(item.replace(/-/gm, '/')).toISOString(),
              y: data.views_data[item].view,
            }))
            .sort(function (a, b) {
              return new Date(b.x) - new Date(a.x)
            }),
        },
        {
          name: i18n.t('message.pages.video.metricsPage.uniqueViews'),
          data: Object.keys(data.views_data)
            .map((item) => ({
              x: new Date(item.replace(/-/gm, '/')).toISOString(),
              y: data.views_data[item].unique_view,
            }))
            .sort(function (a, b) {
              return new Date(b.x) - new Date(a.x)
            }),
        },
        {
          name: i18n.t('message.pages.video.metricsPage.plays'),
          data: Object.keys(data.views_data)
            .map((item) => ({
              x: new Date(item.replace(/-/gm, '/')).toISOString(),
              y: data.views_data[item].play,
            }))
            .sort(function (a, b) {
              return new Date(b.x) - new Date(a.x)
            }),
        },
        {
          name: i18n.t('message.pages.video.metricsPage.uniquePlays'),
          data: Object.keys(data.views_data)
            .map((item) => ({
              x: new Date(item.replace(/-/gm, '/')).toISOString(),
              y: data.views_data[item].unique_play,
            }))
            .sort(function (a, b) {
              return new Date(b.x) - new Date(a.x)
            }),
        },
      ]
    },
    async fetchData() {
      this.loadings.fetch = true
      try {
        const response = await newAnalyticsApi.getAccountMetricsV2(
          format(this.dateRange[0], 'yyyy-MM-dd'),
          format(this.dateRange[1], 'yyyy-MM-dd')
        )
        this.UPDATE_IS_ADBLOCK_ENABLED(false)
        const data = response.data
        this.totalData.views = data.total.view
        this.totalData.uniqueViews = data.total.unique_view
        this.totalData.plays = data.total.play
        this.totalData.uniquePlays = data.total.unique_play
        this.fixAnalyticsChart(data)
        this.errors.fetch = false
      } catch (err) {
        this.errors.tooltipErrMsg =
          err.msg ??
          err.response.data.errMsg ??
          err.response.data.message ??
          'Error'
        this.errors.unknownError = true
        this.errors.shownErrMsg = i18n.t('message.errors.unexpectedError')
        this.errors.fetch = true
      }
      this.loadings.fetch = false
      this.$emit('fetched', { source: 'view' })
    },
    handleOrderByName() {
      if (!this.nameOrder || this.nameOrder === 'desc') {
        this.nameOrder = 'asc'
      } else {
        this.nameOrder = 'desc'
      }
      if (this.nameOrder === 'asc') {
        this.videosData.sort((a, b) =>
          a.title.localeCompare(b.title, undefined, { numeric: true })
        )
      }
      if (this.nameOrder === 'desc') {
        this.videosData.sort(
          (a, b) =>
            -a.title.localeCompare(b.title, undefined, { numeric: true })
        )
      }
    },
    handleOrderByViews() {
      if (!this.viewsOrder || this.viewsOrder === 'desc') {
        this.viewsOrder = 'asc'
      } else {
        this.viewsOrder = 'desc'
      }
      if (this.viewsOrder === 'asc') {
        this.videosData.sort((a, b) => a.view - b.view)
      }
      if (this.viewsOrder === 'desc') {
        this.videosData.sort((a, b) => b.view - a.view)
      }
      if (this.searchVideoText) this.doItemsSearch()
    },
    handleOrderByPlays() {
      if (!this.playsOrder || this.playsOrder === 'desc') {
        this.playsOrder = 'asc'
      } else {
        this.playsOrder = 'desc'
      }
      if (this.playsOrder === 'asc') {
        this.videosData.sort((a, b) => a.play - b.play)
      }
      if (this.playsOrder === 'desc') {
        this.videosData.sort((a, b) => b.play - a.play)
      }
      if (this.searchVideoText) this.doItemsSearch()
    },
    handleOrderByUniqueViews() {
      if (!this.uniqueViewsOrder || this.uniqueViewsOrder === 'desc') {
        this.uniqueViewsOrder = 'asc'
      } else {
        this.uniqueViewsOrder = 'desc'
      }
      if (this.uniqueViewsOrder === 'asc') {
        this.videosData.sort((a, b) => a.unique_view - b.unique_view)
      }
      if (this.uniqueViewsOrder === 'desc') {
        this.videosData.sort((a, b) => b.unique_view - a.unique_view)
      }
      if (this.searchVideoText) this.doItemsSearch()
    },
    handleOrderByUniquePlays() {
      if (!this.uniquePlaysOrder || this.uniquePlaysOrder === 'desc') {
        this.uniquePlaysOrder = 'asc'
      } else {
        this.uniquePlaysOrder = 'desc'
      }
      if (this.uniquePlaysOrder === 'asc') {
        this.videosData.sort((a, b) => a.unique_play - b.unique_play)
      }
      if (this.uniquePlaysOrder === 'desc') {
        this.videosData.sort((a, b) => b.unique_play - a.unique_play)
      }
      if (this.searchVideoText) this.doItemsSearch()
    },
    handleOrderByPlayrate() {
      if (!this.playrateOrder || this.playrateOrder === 'desc') {
        this.playrateOrder = 'asc'
      } else {
        this.playrateOrder = 'desc'
      }
      if (this.playrateOrder === 'asc') {
        this.videosData.sort((a, b) => a.playRate - b.playRate)
      }
      if (this.playrateOrder === 'desc') {
        this.videosData.sort((a, b) => b.playRate - a.playRate)
      }
      if (this.searchVideoText) this.doItemsSearch()
    },
  },
}
</script>

<style lang="scss">
.svgSize {
  width: 450px;
}

.main-scroll {
  border: none !important;
}

.navText {
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 150% !important;
}

.analyticsTable .header-cell {
  justify-content: start !important;
  padding-left: 20px !important;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
}

.analyticsTable .item-cell {
  border-bottom: 0px !important;
  border-top: 1px solid var(--v-contrast-base);
}

.analyticsTable {
  overflow-x: hidden !important;
  background-color: var(--v-dark-newBackground);
}

.analyticsTable .t-header {
  display: none;
}

.bg-dark .analyticsTable .item-line {
  background-color: var(--v-neutral-darken2) !important;
}

.darkThemeSvgFix {
  svg text {
    fill: white;
  }
  .apexcharts-legend-text {
    color: white !important;
  }
}

.analyticsPickerField {
  background-color: #373b54;
}

.mx-datepicker-sidebar {
  overflow: hidden !important;
}

.analyticsHeader {
  border-bottom: 1px solid #e6e8f8;
}

.analyticsNavigation .v-list-item--active {
  border: 1px solid #a0acff;
  border-radius: 4px;
}

.caption.break-text {
  height: 24px;
  color: var(--v-blueMarine-base);
  align-self: flex-start;
  text-align: center;
}
</style>
